export const steps = [
	{
		label: 'Client Info',
	},
	{
		label: 'Product Availability',
	},
	{
		label: 'Options & Pricing',
	},
];
